import { OppgaveStatus } from "../../enums/oppgaveStatus";
import { useAppSelector } from "../../store/reducer";
import { erSamtykkeOppgaveSelector } from "../../store/selectors/selectors-oppgaveDetaljer";

import AnchorLink from "@helsenorge/designsystem-react/components/AnchorLink";

import { useGetResources } from "../../hooks/useGetResources";

import styles from "../../styles/oppgave-detaljer.module.scss";

export const UtfortOppgaveVisning = (): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave!);
  const erSamtykkeOppgave = useAppSelector(erSamtykkeOppgaveSelector);
  const resources = useGetResources();
  if (
    oppgave.Status !== OppgaveStatus.Completed ||
    erSamtykkeOppgave === false
  ) {
    return null;
  }
  return (
    <div className={styles.detaljer_seksjon}>
      <span>{resources?.label_donetext}</span>
      {` `}
      <AnchorLink href="/personverninnstillinger">
        {resources?.label_donetextlink}
      </AnchorLink>
      {`.`}
    </div>
  );
};
